/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const validateJqlResponseSchema = z.object({
  errors: z.array(z.string()).nullish(),
  isValid: z.boolean(),
});
